"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
import { Vue, Component, PropSync } from "vue-property-decorator";
let ColumnLock = class extends Vue {
  addLock() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(this._column.id);
        if (this._column.shopLock === true) {
          yield API.post(`api://base.auth.pro/v1/shops-locks`, {
            shopIds: arr
          });
        } else {
          yield API.delete(`api://base.auth.pro/v1/shops-locks`, {
            data: {
              shopIds: arr
            }
          });
        }
        this.$message.success(this.$t("main.operation_successful"));
      } catch (error) {
        this._column.shopLock = !this._column.shopLock;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("column")
], ColumnLock.prototype, "_column", 2);
__decorateClass([
  Debounce(600)
], ColumnLock.prototype, "addLock", 1);
ColumnLock = __decorateClass([
  Component({
    components: {}
  })
], ColumnLock);
export {
  ColumnLock as default
};
